exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mrf-section{margin:1em}.mrf-section table{width:100%;text-align:left;padding-left:10px;padding-bottom:20px}.mrf-section table td,.mrf-section table th{width:180px;max-width:360px;overflow:hidden;vertical-align:text-top}.mrf-section table td+td,.mrf-section table th+th{width:auto}", ""]);

// exports
